<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<aside
  [@openClose]="(isSlideoutOpen$ | async) ? 'open' : 'closed'"
  (click)="stopPropagation($event)">
  <ng-container *ngComponentOutlet="component$ | async"></ng-container>
</aside>
